import React from 'react';
import { Col, Row } from 'antd';
import { useSelector } from 'react-redux';
import styles from './ProgressFooter.scss';

const ProgressFooter = () => {
  const { total, answered, marked, skipped } = useSelector(state => state.mcq.progress);

  return (
    <div className={styles['progress-footer-wrapper']}>
      <div
        className={`${styles['progress-footer-container']} ${styles['progress-footer-container--no-sections']}`}
      >
        <Row
          gutter={32}
          justify="center"
          align="middle"
          className={styles['progress-footer']}
        >
          <Col>
            Questions:{' '}
            <span className={styles['progress-footer__total']}>
              {String(total).padStart(2, '0')}
            </span>
          </Col>
          <Col>
            Answered:{' '}
            <span className={styles['progress-footer__answered']}>
              {String(answered).padStart(2, '0')}
            </span>
          </Col>
          <Col>
            Marked for review:{' '}
            <span className={styles['progress-footer__marked']}>
              {String(marked).padStart(2, '0')}
            </span>
          </Col>
          <Col>
            Skipped:{' '}
            <span className={styles['progress-footer__skipped']}>
              {String(skipped).padStart(2, '0')}
            </span>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default ProgressFooter;
